import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loginSuccess } from "../features/authSlice";
import { _axios } from "../services/config";
import { Navigate } from "react-router-dom";
import Notification from "../components/ui-elements/Notification";
import PhiliaLoginPic from "../assets/images/PhiliaLoginPic.webp";
import { CiMail } from "react-icons/ci";
import { IoKeyOutline } from "react-icons/io5";
import { IS_LOCAL_ENV } from "../App";
import Footer from "../components/Footer";

const Login = () => {
  const user = useSelector((state) => state.auth.user); // Verificamos si hay usuario logeado
  const dispatch = useDispatch();

  const [password, setPassword] = useState("test"); // Estado local para la password
  const [email, setEmail] = useState("dev@allsavfe.com"); // Estado local del email
  const [redirect, setRedirect] = useState(false); // Si el login es exitoso se coloca en true y se redirije

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await _axios.post("/api/users/login", {
        email: email,
        password: password,
      });
      IS_LOCAL_ENV && console.log(response);
      dispatch(
        loginSuccess({
          user: response.data.user,
          token: response.data.token,
          exp: response.data.exp,
          role: response.data.role,
        })
      );
      localStorage.setItem("tokenExp", response.data.exp);
      setRedirect(true);
    } catch (error) {
      Notification({
        title: "Credenciales inválidas",
        text: "Usuario o contraseña erróneos",
        type: "Error",
      });
    }
    // }
  };

  if (redirect || user) {
    return <Navigate to="/home" />;
  }

  return (
    <>
      <div className="relative min-h-screen flex flex-col md:flex-row">
        <div className="absolute inset-0 flex justify-end hidden sm:flex">
          <img
            src={PhiliaLoginPic}
            alt="Fondo"
            className="object-cover h-full"
          />
        </div>

        <div className="flex flex-row items-center justify-center lg:w-[45%] md:w-[100%] sm:w-[100%] md:bg-white sm:bg-white lg:bg-transparent bg-gradient-to-r from-white from-80% via-white z-10 py-10 px-5">
          <div className="flex justify-center items-center">
            <div className="flex flex-col gap-14 items-center justify-center w-full p-4">
              
              {/* Logo Nectar y Raíz */}
              <div className="bg-dark-green p-8 rounded-full">
                <img
                  src={process.env.PUBLIC_URL + "/Logo-Nectar-V-B.webp"}
                  alt="Logo Nectar y Raíz"
                  className="w-20 h-20"
                />
              </div>

              {/* Login */}
              <div className="flex flex-col items-center justify-center w-full">
                <h1 className="mb-8 font-poppins font-bold text-3xl lg:text-3xl text-dark-green">
                  Login
                </h1>

                <h4 className="mb-12 font-poppins font-[100] text-md lg:text-md text-[#6E6E6E] flex text-center">
                  Introduce tus credenciales para acceder a tu cuenta y seguir{" "}
                  <br />
                  distrutando de nuestras plantas y servicios
                </h4>

                {/* Login Form */}
                <form
                  className="flex w-full max-w-lg flex-col gap-4 items-center justify-center"
                  onSubmit={handleSubmit}
                >
                  <div className="flex flex-col gap-2 w-full">
                    <label
                      className="ml-2 text-dark-green font-bold font-poppins"
                      htmlFor="email"
                    >
                      Email
                    </label>
                    <div className="flex h-14 border rounded-2xl p-4 border-accent-green">
                      <span className="inline-flex items-center h-full w-16 justify-center text-sm text-gray-900 pr-3 border-e border-accent-green">
                        <CiMail className="text-pink-500 text-3xl" />
                      </span>
                      <input
                        className="ml-1 border-none text-dark-green hover:border-none focus:ring-white bg-white focus:outline-red h-full w-full font-poppins"
                        type="text"
                        id="username"
                        name="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="flex flex-col gap-2 w-full ">
                    <label
                      className="ml-2 text-dark-green font-bold font-poppins"
                      htmlFor="password"
                    >
                      Contraseña
                    </label>
                    <div className="flex h-14 border rounded-2xl p-4 border-accent-green">
                      <span className="inline-flex items-center h-full w-16 justify-center text-sm text-gray-900 pr-3 border-e border-accent-green">
                        <IoKeyOutline className="text-pink-500 text-2xl" />
                      </span>
                      <input
                        className="ml-1 border-none text-dark-green hover:border-none focus:ring-white focus:outline-red h-full w-full font-poppins"
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <button
                    className="bg-dark-green text-xl my-6 rounded-full py-6 px-8 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins"
                    type="submit"
                  >
                    Iniciar Sesión
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
